enum ThreeStateValue {
    TRUE = 1,
    FALSE = -1,
    UNDEFINED = 0
}

export default ThreeStateValue;

export const threeStateValueToBool = (value: ThreeStateValue): boolean | undefined => {
    if (value === ThreeStateValue.FALSE) {
        return false;
    }

    if (value === ThreeStateValue.TRUE) {
        return true;
    }

    return undefined;
}

export const boolToThreeStateValue = (value: boolean|undefined): ThreeStateValue => {
    if (value === true) {
        return ThreeStateValue.TRUE;
    }

    if (value === false) {
        return ThreeStateValue.FALSE;
    }

    return ThreeStateValue.UNDEFINED;
}